import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
@Injectable()
export class FixedHazardService {

  constructor(
    private _http: HttpClient
  ) { }
  updatedHazardForm(updatedObj: any){
     return this._http.post(environment.serverUrl + '/task/hazard/', updatedObj);
  }
  previewHazardForm(updatedObj){
    return this._http.post(environment.serverUrl + '/task/preview/', updatedObj);
  }
}



// WEBPACK FOOTER //
// ./src/app/fixed-hazard-form/fixed-hazard.service.ts